import Step from "@material-ui/core/Step";
import Stepper from "@material-ui/core/Stepper";
import _ from "lodash";
import React, { FC } from "react";
import { ExamDayViewModel } from "../../model/ExamDayViewModel";
import { LocationViewModel } from "../../model/LocationViewModel";
import SchedulerDayStepLabel from "./SchedulerDayStepLabel";
import { makeStyles } from "@material-ui/styles";

const useStepStyles = makeStyles((theme) => ({
  stepper: {
    overflowX: "auto",
  },
}));

interface SchedulerExamDayStepsProps {
  locations?: LocationViewModel[];
  examDays?: ExamDayViewModel[];
  selectedExamDayId: string;
  onExamDaySelected?: (examDayId: string) => void;
  onStartAddingExamDay?: () => void;
  showLocation?: boolean;
}

const SchedulerExamDaySteps: FC<SchedulerExamDayStepsProps> = ({
  examDays,
  locations,
  selectedExamDayId,
  showLocation,
  ...eventHandlers
}) => {
    const classes = useStepStyles({});

  const sortedExamDays = _.orderBy(examDays, (examDay) => examDay.date);
  const activeStep = sortedExamDays!.map((day) => day.id).indexOf(selectedExamDayId);

  return (
    <Stepper activeStep={activeStep} className={classes.stepper}>
      {sortedExamDays!.map((examDay, index) => {
        let location: LocationViewModel | undefined;
        if (locations) {
          location = locations.find((l) => l.id === examDay.locationId);
        }

        return (
          <Step
            onClick={() => {
              if (eventHandlers && eventHandlers.onExamDaySelected) {
                eventHandlers.onExamDaySelected(examDay.id);
              }
            }}
            key={examDay.id}
          >
            <SchedulerDayStepLabel
              examDay={examDay}
              location={location}
              isLocationVisible={showLocation}
              isStepActive={activeStep === index}
            />
          </Step>
        );
      })}
    </Stepper>
  );
};

SchedulerExamDaySteps.defaultProps = {
  onStartAddingExamDay: () => {},
  showLocation: false,
  locations: [],
  examDays: [],
} as Partial<SchedulerExamDayStepsProps>;

export default SchedulerExamDaySteps;
